const swiperHomeReview = new Swiper(".swiper-home-review", {
  loop: true,
  slidesPerView: "auto",
  slidesPerGroup: 1,
  spaceBetween: 24,

  breakpoints: {
    768: {
      spaceBetween: 40,
    },
  },

  //   pagination: {
  //     el: ".swiper-pagination",
  //   },

  // Navigation arrows
  navigation: {
    nextEl: ".swiper-next-rev",
    prevEl: ".swiper-prev-rev",
  },
});
